const template = `
  <span id="cookieButton">
    <slot>
        <button>Cookies</button>
    </slot>
  </span>
`;
export default template;
